/* eslint-disable no-useless-escape */
/* eslint camelcase: ["error", {allow: ["min_value"]}] */
import {
  required, email, max, min_value,
} from 'vee-validate/dist/rules';
import { extend, setInteractionMode } from 'vee-validate';


setInteractionMode('eager');
extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: 'This field must be {_fieldValue_} characters or less',
});

extend('min_value', {
  validate(value, { val }:any) {
    return value > val
  },
  params: ['val'],
  message: '{_field_} must be greater than {val}',
});

extend('email', {
  ...email,
  message: 'Please enter a valid email',
});

extend('phoneOptional', {
  validate(value) {
    return (value.length === 0 || value.length === 14)
  },
  message: 'That is not a valid US Phone number',
});

extend('pleaseChoose', {
  validate(value) {
    return (value !== '')
  },
  message: 'Please Pick One',
});

extend('birthdayOptional', {
  validate(value) {
    return (value.length === 0 || value.length === 10)
  },
  message: 'That is not a valid date of birth',
});

extend('validPassword', {
  validate(value) {
    const validTest = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
    return validTest.test(value)
  },
  message: 'That is not a valid password',
});

extend('validCode', {
  validate(value) {
    const validTest = /^(?![\d])([a-zA-Z])([a-zA-Z\d_])+$/
    console.log('testing now: ', value)
    return validTest.test(value)
  },
  message: 'Invalid Code - Only Letters, Numbers, or Understore (_) is Allowed',
});

extend('has_rating', {
  validate(value) {
    console.log('validating the form at: ', value)
    return (Number(value) !== 0)
  },
  message: 'Please Rate {_field_}',
});

extend('phoneRequired', {
  validate(value) {
    return (value.length === 14)
  },
  message: 'That is not a valid US Phone number',
});

extend('birthday', {
  validate(value) {
    if (value.length !== 10) {
      return false
    }
    if (Number(value.substr(0, 2)) > 12) {
      return false
    } if (Number(value.substr(3, 2)) > 31) {
      return false
    } if (Number(value.substr(3, 2)) > 31) {
      return false
    }
    return true
  },
  message: 'That is not a valid birthdate - is it in the form "MM/DD/YYYY?',
});
